import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteKiloClass, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type LateCancelAthleteClassVars = {
  athleteKiloClassId: string;
  chargeNow: boolean;
  chargeDate: string | null;
  chargeFee: number;
  deductCredit: boolean;
  paymentMethod?: string | null;
  taxRate?: number | null;
  nonStripePaymentMethod?: string | null;
  autoPay?: boolean;
  addToNextInvoice?: boolean;
};

export default function useLateCancelAthleteClass(): UseMutationResult<
  AxiosResponse<AthleteKiloClass>,
  AxiosError<ErrorMessage>,
  LateCancelAthleteClassVars
> {
  const queryClient = useQueryClient();

  const lateCancelAthleteClass = ({
    athleteKiloClassId,
    ...payload
  }: LateCancelAthleteClassVars): Promise<AxiosResponse<AthleteKiloClass>> => {
    return client.post(`athlete-kilo-classes/${athleteKiloClassId}/late-cancel/`, payload);
  };

  return useMutation(lateCancelAthleteClass, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['athleteClasses'] });
      queryClient.invalidateQueries({ queryKey: ['athleteEvents'] });
      queryClient.invalidateQueries({ queryKey: ['classes'] });
      queryClient.invalidateQueries({ queryKey: 'events' });
      queryClient.invalidateQueries({ queryKey: ['totalAttended'] });
      queryClient.invalidateQueries({ queryKey: ['totalReserved'] });
    },
  });
}
